// @ts-nocheck — Fase 4 combate estratégico (reemplaza provisional Fase 3)
// src/components/BattleOverlay.ts
import { getSpecies } from '../data/asterias.js';
import { getMove } from '../data/moves.js';
import { getStatus } from '../data/status.js';
import { getWeather } from '../data/weather.js';
import { getTerrain } from '../data/terrain.js';
import { affinityMultiplier } from '../data/affinities.js';
import * as Capture from '../systems/captureSystem.js';
import { createBattle, getActivePlayer, getActiveEnemy, executeTurn, canSwitch, syncBattleToInstances, applyVictoryRewards } from '../systems/combat/engine.js';
import type { Battle } from '../systems/combat/engine.js';
import { store } from '../app/state.js';
import { saveLocal } from '../app/storage.js';
import { GAME_CONFIG } from '../data/gameConfig.js';
import { createInstance } from '../entities/asteria.js';

export type BattleCallbacks = {
  onCaptureSuccess: (sp:any, lvl:number)=>void;
  onFlee: ()=>void;
  onDefeat: ()=>void;
  onVictory: ()=>void;
};

export class BattleOverlay {
  el: HTMLElement;
  private battle: Battle | null = null;
  private callbacks: BattleCallbacks;
  private timePhase: any = 'dia';
  // dom refs
  private logEl!: HTMLElement;
  private enemyHpBar!: HTMLElement; private enemyHpText!: HTMLElement; private enemyEnergyBar!: HTMLElement;
  private playerHpBar!: HTMLElement; private playerHpText!: HTMLElement; private playerEnergyBar!: HTMLElement;
  private movesEl!: HTMLElement; private actionsEl!: HTMLElement; private fieldEl!: HTMLElement;
  private enemyStatusEl!: HTMLElement; private playerStatusEl!: HTMLElement;

  constructor(cb: BattleCallbacks){
    this.callbacks = cb;
    this.el = document.createElement('div');
    this.el.style.cssText = 'position:absolute;inset:0;background:radial-gradient(1000px 600px at 50% -10%, rgba(106,92,255,.18), transparent 60%), linear-gradient(180deg, #0b1020 0%, #0a1430 55%, #0f1f3a 100%);display:none;z-index:15;flex-direction:column;padding:.6rem;overflow:auto;';
    this.el.innerHTML = `
      <div style="max-width:860px;width:100%;margin:auto;display:grid;gap:.7rem">
        <div style="display:flex;justify-content:space-between;gap:.5rem;align-items:center;flex-wrap:wrap">
          <span class="chip" style="background:rgba(0,0,0,.5)">⚔ COMBATE ESTRATÉGICO</span>
          <span data-role="field" style="display:flex;gap:.4rem;flex-wrap:wrap"></span>
          <span class="chip" data-role="turn" style="background:rgba(255,207,107,.18)">Turno 1</span>
        </div>

        <div style="display:grid;grid-template-columns:1.15fr .95fr;gap:.7rem;align-items:stretch">
          <!-- Enemigo -->
          <div style="background:linear-gradient(180deg, rgba(18,26,51,.97), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:16px;overflow:hidden;box-shadow:0 16px 40px rgba(0,0,0,.4)">
            <div style="height:200px;position:relative;overflow:hidden;background:radial-gradient(600px 220px at 50% 0%, rgba(124,240,255,.10), transparent 60%), linear-gradient(180deg, #0f1b3a, #0a1430);display:grid;place-items:center">
              <canvas data-role="enemy-canvas" width="220" height="200" style="width:220px;height:200px;image-rendering:pixelated"></canvas>
              <div data-role="enemy-badge" style="position:absolute;top:.5rem;left:.5rem;display:flex;gap:.3rem;flex-wrap:wrap"></div>
              <div data-role="enemy-status" style="position:absolute;top:.5rem;right:.5rem;display:flex;gap:.3rem"></div>
            </div>
            <div style="padding:.65rem .75rem">
              <div style="display:flex;justify-content:space-between;align-items:baseline;gap:.5rem">
                <div data-role="enemy-name" style="font-family:var(--font-display);font-weight:800;font-size:1.1rem">—</div>
                <div data-role="enemy-level" style="font-family:var(--font-mono);font-size:.76rem;color:var(--muted)">Nv. —</div>
              </div>
              <div style="margin-top:.4rem;display:grid;gap:.35rem">
                <div style="height:9px;border-radius:999px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.08);overflow:hidden"><div data-role="enemy-hp" style="height:100%;width:100%;background:linear-gradient(90deg, #3dd68c, #7cf0ff);transition:width .3s"></div></div>
                <div style="display:flex;justify-content:space-between;font-family:var(--font-mono);font-size:.68rem;color:var(--muted)"><span>PS</span><span data-role="enemy-hp-text">—/—</span></div>
                <div style="height:6px;border-radius:999px;background:rgba(255,255,255,.06);overflow:hidden"><div data-role="enemy-energy" style="height:100%;width:100%;background:linear-gradient(90deg, #ffcf6b, #ffd23a)"></div></div>
                <div style="display:flex;justify-content:space-between;font-family:var(--font-mono);font-size:.66rem;color:var(--muted)"><span>EN</span><span data-role="enemy-energy-text">—/—</span></div>
              </div>
              <div data-role="enemy-meta" style="margin-top:.4rem;display:flex;gap:.3rem;flex-wrap:wrap"></div>
            </div>
          </div>

          <!-- Jugador -->
          <div style="display:grid;gap:.6rem">
            <div style="background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:14px;padding:.6rem">
              <div style="display:flex;justify-content:space-between;align-items:center">
                <span style="font-family:var(--font-mono);font-size:.66rem;letter-spacing:.1em;text-transform:uppercase;color:var(--muted)">Tu Asteria</span>
                <span data-role="player-ability" class="chip" style="font-size:.62rem"></span>
              </div>
              <div style="display:flex;justify-content:space-between;align-items:baseline;gap:.5rem;margin-top:.3rem">
                <div data-role="player-name" style="font-weight:800">—</div>
                <div data-role="player-level" style="font-family:var(--font-mono);font-size:.74rem;color:var(--muted)">Nv. —</div>
              </div>
              <div data-role="player-status" style="display:flex;gap:.3rem;margin-top:.3rem;flex-wrap:wrap"></div>
              <div style="margin-top:.4rem;height:9px;border-radius:999px;background:rgba(255,255,255,.08);overflow:hidden"><div data-role="player-hp" style="height:100%;width:100%;background:linear-gradient(90deg, #3dd68c, #7cf0ff)"></div></div>
              <div style="display:flex;justify-content:space-between;font-family:var(--font-mono);font-size:.68rem;color:var(--muted)"><span>PS</span><span data-role="player-hp-text">—</span></div>
              <div style="height:6px;border-radius:999px;background:rgba(255,255,255,.06);overflow:hidden;margin-top:.2rem"><div data-role="player-energy" style="height:100%;width:100%;background:linear-gradient(90deg, #ffcf6b, #ffd23a)"></div></div>
              <div style="display:flex;justify-content:space-between;font-family:var(--font-mono);font-size:.66rem;color:var(--muted)"><span>EN</span><span data-role="player-energy-text">—</span></div>
              <div style="margin-top:.3rem;height:4px;border-radius:999px;background:rgba(255,255,255,.06);overflow:hidden" title="XP"><div data-role="player-xp" style="height:100%;width:0%;background:linear-gradient(90deg, #6a5cff, #7cf0ff)"></div></div>
              <div style="font-family:var(--font-mono);font-size:.62rem;color:var(--muted);text-align:right" data-role="player-xp-text">XP 0/20</div>
            </div>

            <div data-role="moves" style="display:grid;gap:.4rem"></div>
            <div data-role="actions" style="display:grid;grid-template-columns:1fr 1fr;gap:.4rem"></div>
          </div>
        </div>

        <div data-role="log" style="background:rgba(0,0,0,.45);border:1px solid rgba(255,255,255,.08);border-radius:12px;padding:.5rem .6rem;font-family:var(--font-mono);font-size:.72rem;line-height:1.5;min-height:3.2rem;max-height:110px;overflow:auto;color:var(--muted)"></div>
        <div style="display:flex;justify-content:space-between;align-items:center;gap:.5rem;flex-wrap:wrap">
          <div style="display:flex;gap:.4rem;flex-wrap:wrap">
            <span class="chip" style="background:rgba(124,240,255,.08)">Afinidad: tabla original Aetheria</span>
            <span class="chip" style="background:rgba(255,207,107,.12)">Clima+Terreno acumulables</span>
          </div>
          <span style="font-family:var(--font-mono);font-size:.66rem;color:var(--muted)">Fase 4 · 1v1 · Energía + Estados</span>
        </div>
      </div>
    `;
    this.logEl = this.el.querySelector('[data-role="log"]') as HTMLElement;
    this.enemyHpBar = this.el.querySelector('[data-role="enemy-hp"]') as HTMLElement;
    this.enemyHpText = this.el.querySelector('[data-role="enemy-hp-text"]') as HTMLElement;
    this.enemyEnergyBar = this.el.querySelector('[data-role="enemy-energy"]') as HTMLElement;
    this.playerHpBar = this.el.querySelector('[data-role="player-hp"]') as HTMLElement;
    this.playerHpText = this.el.querySelector('[data-role="player-hp-text"]') as HTMLElement;
    this.playerEnergyBar = this.el.querySelector('[data-role="player-energy"]') as HTMLElement;
    this.movesEl = this.el.querySelector('[data-role="moves"]') as HTMLElement;
    this.actionsEl = this.el.querySelector('[data-role="actions"]') as HTMLElement;
    this.fieldEl = this.el.querySelector('[data-role="field"]') as HTMLElement;
    this.enemyStatusEl = this.el.querySelector('[data-role="enemy-status"]') as HTMLElement;
    this.playerStatusEl = this.el.querySelector('[data-role="player-status"]') as HTMLElement;
  }

  startWild(speciesId:string, level:number, timePhase:string){
    const team = store.get().team.asterias;
    const battle = createBattle({ playerTeam: team, wildSpeciesId: speciesId, wildLevel: level });
    this.timePhase = timePhase;
    this.battle = battle;
    this.el.style.display='flex';
    this.refresh();
    this.log(battle.log.map(l=>l.text).join('\n'));
  }

  startTrainer(trainerId:string){
    const mod = (store.get() as any);
    // trainer import dinámico para evitar ciclo
    // @ts-ignore
    import('../data/trainers.js').then(m=>{
      const tr = m.TRAINERS.find((t:any)=> t.id===trainerId);
      if(!tr) return;
      const battle = createBattle({ playerTeam: store.get().team.asterias, trainer: tr });
      this.battle = battle;
      this.el.style.display='flex';
      this.refresh();
    });
  }

  private log(text:string){ this.logEl.textContent = text; this.logEl.scrollTop = this.logEl.scrollHeight; }

  private refresh(): void {
    if(!this.battle) return;
    const b = this.battle;
    const player = b.playerTeam[b.playerActive];
    const enemy = b.enemyTeam[b.enemyActive];
    // field
    const w = getWeather(b.field.weather.id);
    const t = getTerrain(b.field.terrain.id);
    this.fieldEl.innerHTML = `
      <span class="chip" style="background:rgba(124,240,255,.12)">${w?.name ?? b.field.weather.id} ${b.field.weather.turns<99?`(${b.field.weather.turns})`:''}</span>
      <span class="chip" style="background:rgba(61,214,140,.12)">${t?.name ?? b.field.terrain.id} ${b.field.terrain.turns<99?`(${b.field.terrain.turns})`:''}</span>
      <span class="chip">${b.isTrainer? 'Entrenador: '+b.trainer?.name : 'Salvaje'}</span>
    `;
    (this.el.querySelector('[data-role="turn"]') as HTMLElement).textContent = `Turno ${b.turn}`;
    // enemy
    (this.el.querySelector('[data-role="enemy-name"]') as HTMLElement).textContent = enemy.name;
    (this.el.querySelector('[data-role="enemy-level"]') as HTMLElement).textContent = `Nv. ${enemy.level}`;
    (this.el.querySelector('[data-role="enemy-badge"]') as HTMLElement).innerHTML = `<span class="chip">${enemy.species.element}</span><span class="chip">${enemy.species.rarity}</span>`;
    this.enemyHpBar.style.width = `${Math.max(0, enemy.hp/enemy.maxHp*100)}%`;
    this.enemyHpBar.style.background = enemy.hp/enemy.maxHp>0.5? 'linear-gradient(90deg, #3dd68c, #7cf0ff)' : enemy.hp/enemy.maxHp>0.2? 'linear-gradient(90deg, #ffcf6b, #ffb86b)' : 'linear-gradient(90deg, #ff5c7a, #ff8a5c)';
    this.enemyHpText.textContent = `${enemy.hp}/${enemy.maxHp}`;
    this.enemyEnergyBar.style.width = `${enemy.energy/enemy.maxEnergy*100}%`;
    (this.el.querySelector('[data-role="enemy-energy-text"]') as HTMLElement).textContent = `${enemy.energy}/${enemy.maxEnergy}`;
    (this.el.querySelector('[data-role="enemy-meta"]') as HTMLElement).innerHTML = `<span class="chip">${enemy.species.role}</span><span class="chip" style="background:${enemy.species.color};color:#fff">${enemy.abilityId}</span>`;
    this.enemyStatusEl.innerHTML = enemy.status ? `<span class="chip" style="background:rgba(255,92,122,.18)">${getStatus(enemy.status.id)?.name ?? enemy.status.id} (${enemy.status.turns})</span>` : '';
    // player
    (this.el.querySelector('[data-role="player-name"]') as HTMLElement).textContent = player.name;
    (this.el.querySelector('[data-role="player-level"]') as HTMLElement).textContent = `Nv. ${player.level}`;
    (this.el.querySelector('[data-role="player-ability"]') as HTMLElement).textContent = player.abilityId;
    this.playerHpBar.style.width = `${Math.max(0, player.hp/player.maxHp*100)}%`;
    this.playerHpText.textContent = `${player.hp}/${player.maxHp}`;
    this.playerEnergyBar.style.width = `${player.energy/player.maxEnergy*100}%`;
    (this.el.querySelector('[data-role="player-energy-text"]') as HTMLElement).textContent = `${player.energy}/${player.maxEnergy}`;
    const xpPct = player.instance ? (player.instance.xp / player.instance.xpToNext)*100 : 0;
    (this.el.querySelector('[data-role="player-xp"]') as HTMLElement).style.width = `${xpPct}%`;
    (this.el.querySelector('[data-role="player-xp-text"]') as HTMLElement).textContent = player.instance ? `XP ${player.instance.xp}/${player.instance.xpToNext}` : '—';
    this.playerStatusEl.innerHTML = player.status ? `<span class="chip" style="background:rgba(255,92,122,.18)">${getStatus(player.status.id)?.name ?? player.status.id} (${player.status.turns})</span>` : '';
    // canvas
    this.drawEnemyCanvas(enemy);
    // moves
    this.renderMoves();
    this.renderActions();
    this.log(b.log.slice(-6).map(l=>l.text).join('\n'));
    // si alguien fainted y es trainer, el motor ya cambió enemyActive, pero si player fainted, pedir switch
    if(player.hp<=0 && b.result==='ongoing'){
      this.renderSwitchPrompt();
    }
  }

  private drawEnemyCanvas(unit:any): void {
    const c = this.el.querySelector('[data-role="enemy-canvas"]') as HTMLCanvasElement;
    const ctx = c.getContext('2d')!;
    ctx.clearRect(0,0,c.width,c.height);
    const g = ctx.createRadialGradient(110,40,10,110,40,140);
    g.addColorStop(0, unit.species.accent+'55'); g.addColorStop(1,'transparent');
    ctx.fillStyle=g; ctx.fillRect(0,0,c.width,c.height);
    ctx.save(); ctx.translate(110,110);
    ctx.fillStyle=unit.species.color; ctx.strokeStyle='#fff'; ctx.lineWidth=1.6;
    const s = unit.species.silhouette as string;
    if(s==='hoja'){ ctx.beginPath(); ctx.ellipse(0,10,58,48,0,0,Math.PI*2); ctx.fill(); ctx.stroke(); }
    else if(s==='chispa'){ ctx.beginPath(); ctx.arc(0,0,34,0,Math.PI*2); ctx.fill(); ctx.beginPath(); ctx.arc(0,0,48,0,Math.PI*1.2); ctx.stroke(); }
    else if(s==='ajolote'){ ctx.beginPath(); ctx.ellipse(0,18,46,28,0,0,Math.PI*2); ctx.fill(); }
    else if(s==='draco'){ ctx.beginPath(); ctx.ellipse(0,12,52,30,0,0,Math.PI*2); ctx.fill(); }
    else if(s==='polilla'){ ctx.beginPath(); ctx.ellipse(-28,0,32,22,-0.2,0,Math.PI*2); ctx.fill(); ctx.beginPath(); ctx.ellipse(28,0,32,22,0.2,0,Math.PI*2); ctx.fill(); }
    else { ctx.beginPath(); ctx.moveTo(-36,22); ctx.lineTo(0,-28); ctx.lineTo(36,22); ctx.closePath(); ctx.fill(); }
    ctx.fillStyle='rgba(0,0,0,.18)'; ctx.beginPath(); ctx.ellipse(0,56,42,8,0,0,Math.PI*2); ctx.fill();
    ctx.restore();
    ctx.fillStyle='rgba(0,0,0,.5)'; ctx.fillRect(0,182,c.width,18);
    ctx.fillStyle='#fff'; ctx.font='600 10px Inter'; ctx.fillText(`${unit.species.name} · ${unit.species.element} · ${unit.level}`,8,194);
  }

  private renderMoves(): void {
    if(!this.battle) return;
    const b = this.battle;
    if(b.result!=='ongoing'){ this.movesEl.innerHTML=''; return; }
    const player = b.playerTeam[b.playerActive];
    if(player.hp<=0){ this.movesEl.innerHTML='<div style="font-size:.82rem;color:var(--muted);text-align:center">Elige otra Asteria para continuar</div>'; return; }
    this.movesEl.innerHTML = player.moves.map(m=>{
      const aff = affinityMultiplier(m.element, b.enemyTeam[b.enemyActive].species.element);
      let eff = '';
      if(aff>=1.5) eff='▲'; else if(aff<=0.5) eff='▼';
      const can = player.energy >= m.energyCost ? '' : 'opacity:.45;pointer-events:none';
      return `<button data-move="${m.id}" type="button" class="btn btn--ghost" style="justify-content:space-between;${can}">
        <span>${m.name} <span style="font-size:.66rem;color:var(--muted)">${m.element} · ${m.category} · ${m.energyCost}EN ${eff}</span></span>
        <span style="font-family:var(--font-mono);font-size:.68rem">${m.power?m.power:''} ${m.power?'·':''} ${Math.round(m.accuracy*100)}%</span>
      </button>`;
    }).join('');
    this.movesEl.querySelectorAll<HTMLButtonElement>('[data-move]').forEach(btn=>{
      btn.addEventListener('click',()=> this.handleMove(btn.dataset.move!));
    });
  }

  private renderActions(): void {
    if(!this.battle) return;
    const b = this.battle;
    if(b.result!=='ongoing'){ this.actionsEl.innerHTML=''; return; }
    const nucleos = store.get().inventory.find(i=>i.id==='nucleo_vinculo')?.qty ?? 0;
    const canCapture = b.captureAllowed;
    this.actionsEl.innerHTML = `
      <button data-action="switch" type="button" class="btn btn--subtle">⇄ Cambiar</button>
      <button data-action="bag" type="button" class="btn btn--subtle">🎒 Mochila</button>
      <button data-action="capture" type="button" class="btn btn--primary" style="${!canCapture || nucleos<=0?'opacity:.45;pointer-events:none':''}">${canCapture?`⬢ Capturar (${nucleos})`:'No capturable'}</button>
      <button data-action="flee" type="button" class="btn btn--subtle">${b.isTrainer?'No huir':'↯ Huir'}</button>
    `;
    this.actionsEl.querySelector<HTMLButtonElement>('[data-action="switch"]')!.addEventListener('click',()=> this.renderSwitchPrompt());
    this.actionsEl.querySelector<HTMLButtonElement>('[data-action="bag"]')!.addEventListener('click',()=> this.renderBag());
    this.actionsEl.querySelector<HTMLButtonElement>('[data-action="capture"]')!.addEventListener('click',()=> this.handleCapture());
    this.actionsEl.querySelector<HTMLButtonElement>('[data-action="flee"]')!.addEventListener('click',()=> this.handleFlee());
  }

  private renderSwitchPrompt(): void {
    if(!this.battle) return;
    const b = this.battle;
    const box = document.createElement('div');
    box.style.cssText='position:absolute;inset:0;background:rgba(7,11,26,.92);display:grid;place-items:center;padding:1rem;z-index:20;';
    const team = b.playerTeam;
    box.innerHTML=`
      <div style="width:min(520px,96vw);background:linear-gradient(180deg, rgba(18,26,51,.98), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:16px;padding:1rem">
        <div style="font-weight:800;font-family:var(--font-display)">Elige Asteria</div>
        <div style="display:grid;gap:.5rem;margin-top:.6rem">
          ${team.map((u,i)=>`
            <button data-idx="${i}" type="button" class="btn ${i===b.playerActive?'btn--primary':u.hp<=0?'btn--subtle':''}" style="justify-content:space-between;${u.hp<=0?'opacity:.45;pointer-events:none':''};${!canSwitch(b,i) && i!==b.playerActive?'opacity:.45;pointer-events:none':''}">
              <span>${u.name} Nv.${u.level} ${u.instance?`· Vínculo ${u.instance.bond}`:''}</span>
              <span style="font-family:var(--font-mono);font-size:.72rem">${u.hp}/${u.maxHp} PS · ${u.energy}/${u.maxEnergy} EN ${u.status?`· ${u.status.id}`:''}</span>
            </button>
          `).join('')}
        </div>
        <button data-cancel type="button" class="btn btn--ghost" style="margin-top:.6rem">Cancelar</button>
      </div>
    `;
    box.querySelectorAll<HTMLButtonElement>('[data-idx]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const idx = Number(btn.dataset.idx);
        if(!canSwitch(b, idx) && idx!==b.playerActive){ return; }
        // si el activo está debilitado, permitir switch sin turno enemigo? Pero motor maneja switch con ataque enemigo
        const res = executeTurn(b, { type:'switch', index: idx });
        box.remove();
        this.refresh();
        this.checkEnd();
      });
    });
    box.querySelector<HTMLButtonElement>('[data-cancel]')!.addEventListener('click',()=> box.remove());
    this.el.appendChild(box);
  }

  private renderBag(): void {
    if(!this.battle) return;
    const inv = store.get().inventory;
    const box = document.createElement('div');
    box.style.cssText='position:absolute;inset:0;background:rgba(7,11,26,.92);display:grid;place-items:center;padding:1rem;z-index:20;';
    box.innerHTML=`
      <div style="width:min(420px,96vw);background:linear-gradient(180deg, rgba(18,26,51,.98), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:16px;padding:1rem">
        <div style="font-weight:800">Mochila</div>
        <div style="display:grid;gap:.5rem;margin-top:.6rem">
          ${(inv.length? inv : [{id:'vacío', qty:0}]).map(it=>`
            <button data-item="${it.id}" type="button" class="btn btn--ghost" style="justify-content:space-between">
              <span>${it.id} ×${it.qty}</span><span style="font-size:.72rem;color:var(--muted)">${it.id==='pocion_aurea'?'Cura 35 PS': it.id==='cristal_lumen'?'Restaura 3 EN': it.id==='nucleo_vinculo'?'Captura':''}</span>
            </button>
          `).join('')}
        </div>
        <button data-close type="button" class="btn btn--subtle" style="margin-top:.6rem">Cerrar</button>
      </div>
    `;
    box.querySelectorAll<HTMLButtonElement>('[data-item]').forEach(btn=>{
      btn.addEventListener('click',()=>{
        const id = btn.dataset.item!;
        if(id==='pocion_aurea' || id==='cristal_lumen'){
          const b = this.battle!;
          const res = executeTurn(b, { type:'item', itemId:id });
          // consumir del store
          const st = store.get();
          const it = st.inventory.find(i=> i.id===id);
          if(it && it.qty>0){ it.qty--; store.setState(st); saveLocal(st); }
          box.remove();
          this.refresh();
          this.checkEnd();
        }
      });
    });
    box.querySelector<HTMLButtonElement>('[data-close]')!.addEventListener('click',()=> box.remove());
    this.el.appendChild(box);
  }

  private async handleMove(moveId:string){
    if(!this.battle || this.battle.result!=='ongoing') return;
    const playerMove = getMove(moveId);
    if(!playerMove) return;
    // verificar energía ya en engine, pero UI bloquea si no alcanza
    const res = executeTurn(this.battle, { type:'move', moveId });
    this.refresh();
    await new Promise(r=> setTimeout(r, 300));
    this.checkEnd();
  }

  private handleCapture(): void {
    if(!this.battle || !this.battle.captureAllowed) return;
    const b = this.battle;
    const enemy = b.enemyTeam[b.enemyActive];
    const st = store.get();
    const nucleos = st.inventory.find(i=> i.id==='nucleo_vinculo')?.qty ?? 0;
    if(nucleos<=0){ b.log.push({text:'¡No te quedan Núcleos!'}); this.refresh(); return; }
    // consumir
    const it = st.inventory.find(i=> i.id==='nucleo_vinculo')!;
    it.qty--; store.setState(st); saveLocal(st);
    // cálculo via Capture system
    const chance = Capture.calcCaptureChance({ species: enemy.species, wildInstance: { level: enemy.level, hp: enemy.hp, maxHp: enemy.maxHp }, nucleo:'nucleo_vinculo', timePhase: 'dia' as any });
    const roll = Math.random();
    b.log.push({ text:`Lanzas Núcleo... Prob. ${Math.round(chance*100)}% (roll ${roll.toFixed(2)})` });
    this.refresh();
    setTimeout(()=>{
      if(roll < chance){
        // éxito
        const inst = createInstance(enemy.species, enemy.level, store.get().world.zoneId);
        inst.hp = Math.max(1, Math.floor(inst.maxHp * (enemy.hp / enemy.maxHp)));
        if(st.team.asterias.length < GAME_CONFIG.maxTeamSize) st.team.asterias.push(inst);
        else st.team.boxed.push(inst);
        const reg = st.registry[enemy.species.id] ?? { seen:true, caught:false, countSeen:0, countCaught:0 };
        reg.caught=true; reg.caughtAt=new Date().toISOString(); reg.countCaught=(reg.countCaught||0)+1;
        st.registry[enemy.species.id]=reg;
        st.stats.asteriasCaptured = (st.stats.asteriasCaptured||0)+1;
        store.setState(st); saveLocal(st);
        this.showCaptureSuccess(inst, enemy.species);
        b.result='victory';
        this.callbacks.onCaptureSuccess(enemy.species, enemy.level);
      } else {
        b.log.push({ text:'¡El Núcleo falló! La Asteria se libera.' });
        // enemigo ataca tras fallo
        const enemyMove = enemy.moves[Math.floor(Math.random()*enemy.moves.length)];
        if(enemyMove) {
          const res = executeTurn(b, { type:'move', moveId: getActivePlayer(b).moves[0]?.id ?? 'pulso_suave' }, enemyMove.id);
          // Actually capture fallo ya consumió turno jugador, ahora enemigo ataca
        }
        this.refresh();
      }
    }, 1100);
  }

  private showCaptureSuccess(inst:any, sp:any): void {
    const box=document.createElement('div');
    box.style.cssText='position:absolute;inset:0;background:rgba(7,11,26,.92);display:grid;place-items:center;padding:1rem;z-index:22';
    box.innerHTML=`
      <div style="width:min(520px,96vw);background:linear-gradient(180deg, rgba(18,26,51,.98), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:18px;padding:1.2rem;text-align:center">
        <div style="font-family:var(--font-mono);font-size:.68rem;letter-spacing:.14em;color:var(--success)">¡Captura exitosa!</div>
        <div style="margin:.6rem auto;width:110px;height:110px;border-radius:18px;background:radial-gradient(circle at 30% 30%, #fff, ${sp.accent} 35%, ${sp.color} 70%);display:grid;place-items:center;font-size:38px">✦</div>
        <div style="font-family:var(--font-display);font-weight:800;font-size:1.4rem">${sp.name} Nv.${inst.level}</div>
        <div style="font-size:.82rem;color:var(--muted)">${sp.element} · ${sp.rarity} · Vínculo ${inst.bond}</div>
        <button data-close type="button" class="btn btn--primary" style="margin-top:1rem">¡Genial!</button>
      </div>
    `;
    box.querySelector<HTMLButtonElement>('[data-close]')!.addEventListener('click',()=>{ box.remove(); this.hide(); });
    this.el.appendChild(box);
  }

  private handleFlee(): void {
    if(!this.battle) return;
    const b = this.battle;
    const res = executeTurn(b, { type:'flee' });
    this.refresh();
    if(b.result==='fled'){
      setTimeout(()=>{ this.hide(); this.callbacks.onFlee(); }, 800);
    } else {
      // si no huyó, el motor ya hizo que enemigo atacara
    }
  }

  private checkEnd(): void {
    if(!this.battle) return;
    const b = this.battle;
    if(b.result==='victory'){
      // recompensas
      const st = store.get();
      const rewards = applyVictoryRewards(b, st);
      syncBattleToInstances(b, st);
      st.stats.battlesWon = (st.stats.battlesWon||0)+1;
      // curar un poco? no
      store.setState(st); saveLocal(st);
      // mostrar victoria
      const box=document.createElement('div');
      box.style.cssText='position:absolute;inset:0;background:rgba(7,11,26,.9);display:grid;place-items:center;padding:1rem;z-index:22';
      box.innerHTML=`
        <div style="width:min(540px,96vw);background:linear-gradient(180deg, rgba(18,26,51,.98), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:18px;padding:1.2rem;text-align:center">
          <div style="font-family:var(--font-display);font-weight:800;font-size:1.4rem">¡VICTORIA!</div>
          <div style="font-family:var(--font-mono);font-size:.78rem;color:var(--muted)">+${rewards.xpGained} XP · +${rewards.aureos} aureos ${rewards.leveled.length? '· Subida: '+rewards.leveled.join(', '):''}</div>
          <div style="margin-top:.6rem;display:grid;gap:.4rem">
            ${rewards.items.map((it:any)=>`<span class="chip">${it.id} ×${it.qty}</span>`).join('')}
            <span class="chip">Vínculo +2</span>
          </div>
          <button data-close type="button" class="btn btn--primary" style="margin-top:1rem">Continuar</button>
        </div>
      `;
      box.querySelector<HTMLButtonElement>('[data-close]')!.addEventListener('click',()=>{
        box.remove();
        this.hide();
        this.callbacks.onVictory();
      });
      this.el.appendChild(box);
    } else if(b.result==='defeat' || b.result==='fled'){
      syncBattleToInstances(b, store.get());
      saveLocal(store.get());
      if(b.result==='defeat'){
        const box=document.createElement('div');
        box.style.cssText='position:absolute;inset:0;background:rgba(7,11,26,.92);display:grid;place-items:center;padding:1rem;z-index:22';
        box.innerHTML=`
          <div style="width:min(480px,96vw);background:linear-gradient(180deg, rgba(18,26,51,.98), rgba(14,20,42,.99));border:1px solid rgba(255,255,255,.12);border-radius:18px;padding:1.2rem;text-align:center">
            <div style="font-family:var(--font-display);font-weight:800;font-size:1.3rem;color:var(--danger)">Derrota</div>
            <p style="font-size:.88rem;color:var(--muted);margin-top:.4rem">Tus Asterias necesitan descansar. Regresas a Villa Aurelia.</p>
            <button data-close type="button" class="btn btn--ghost" style="margin-top:1rem">Volver</button>
          </div>
        `;
        box.querySelector<HTMLButtonElement>('[data-close]')!.addEventListener('click',()=>{
          box.remove(); this.hide(); this.callbacks.onDefeat();
        });
        this.el.appendChild(box);
      } else {
        this.hide();
      }
    } else {
      // si player fainted y hay reemplazo, mostrar prompt
      const player = b.playerTeam[b.playerActive];
      if(player.hp<=0){
        this.renderSwitchPrompt();
      }
    }
  }

  hide(): void { this.el.style.display='none'; this.battle=null; }
  isVisible(): boolean { return this.el.style.display!=='none'; }
}
